var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/common';
import DeleteModal from '@/common/delete-modal';
import Header from '@/common/header';
import SidePanel from '@/common/side-panel';
import UpdateCronModal from '@/common/update-cron-modal';
import { useMutation } from '@/hoc/hooks/useMutation';
import { useQuery } from '@/hoc/hooks/useQuery';
import { DownArrow, EditIcon, PlusIcon, TrashIcon, UpArrow } from '@/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
var initialData = [];
var columns = [
    { label: 'Config', key: 'config', mobilePriority: true },
    { label: 'Encryption Type', key: 'encryptionType', mobilePriority: true },
    { label: 'Schedule Type', key: 'scheduleType', mobilePriority: false },
    { label: 'Notification Email', key: 'notificationEmail', mobilePriority: false },
    { label: 'Frequency', key: 'frequeny', mobilePriority: false },
    { label: 'Date & time', key: 'date-time', mobilePriority: true },
    { label: 'Edit', key: 'edit', mobilePriority: true },
    { label: 'Delete', key: 'delete', mobilePriority: true },
    { label: 'View Log', key: 'view-log', mobilePriority: true },
    { label: 'Last Job Duration', key: 'view-log', mobilePriority: true },
];
export var frequencies = [
    { label: 'Every Minute', value: '* * * * *' },
    { label: 'Every 2 Minutes', value: '*/2 * * * *' },
    { label: 'Every 3 Minutes', value: '*/3 * * * *' },
    { label: 'Every 4 Minutes', value: '*/4 * * * *' },
    { label: 'Every 5 Minutes', value: '*/5 * * * *' },
    { label: 'Every 6 Minutes', value: '*/6 * * * *' },
    { label: 'Every 10 Minutes', value: '*/10 * * * *' },
    { label: 'Every 12 Minutes', value: '*/12 * * * *' },
    { label: 'Every 15 Minutes', value: '*/15 * * * *' },
    { label: 'Every 20 Minutes', value: '*/20 * * * *' },
    { label: 'Every 30 Minutes', value: '*/30 * * * *' },
    { label: 'Hourly', value: '0 * * * *' },
    { label: 'Every 2 Hours', value: '0 */2 * * *' },
    { label: 'Every 3 Hours', value: '0 */3 * * *' },
    { label: 'Every 4 Hours', value: '0 */4 * * *' },
    { label: 'Every 6 Hours', value: '0 */6 * * *' },
    { label: 'Every 8 Hours', value: '0 */8 * * *' },
    { label: 'Every 12 Hours', value: '0 */12 * * *' },
    { label: 'Daily at Midnight', value: '0 0 * * *' },
    { label: 'Daily at 1 AM', value: '0 1 * * *' },
    { label: 'Daily at 2 AM', value: '0 2 * * *' },
    { label: 'Daily at 3 AM', value: '0 3 * * *' },
    { label: 'Daily at 4 AM', value: '0 4 * * *' },
    { label: 'Daily at 5 AM', value: '0 5 * * *' },
    { label: 'Daily at 6 AM', value: '0 6 * * *' },
    { label: 'Daily at 7 AM', value: '0 7 * * *' },
    { label: 'Daily at 8 AM', value: '0 8 * * *' },
    { label: 'Daily at 9 AM', value: '0 9 * * *' },
    { label: 'Daily at 10 AM', value: '0 10 * * *' },
    { label: 'Daily at 11 AM', value: '0 11 * * *' },
    { label: 'Daily at Noon', value: '0 12 * * *' },
    { label: 'Daily at 1 PM', value: '0 13 * * *' },
    { label: 'Daily at 2 PM', value: '0 14 * * *' },
    { label: 'Daily at 3 PM', value: '0 15 * * *' },
    { label: 'Daily at 4 PM', value: '0 16 * * *' },
    { label: 'Daily at 5 PM', value: '0 17 * * *' },
    { label: 'Daily at 6 PM', value: '0 18 * * *' },
    { label: 'Daily at 7 PM', value: '0 19 * * *' },
    { label: 'Daily at 8 PM', value: '0 20 * * *' },
    { label: 'Daily at 9 PM', value: '0 21 * * *' },
    { label: 'Daily at 10 PM', value: '0 22 * * *' },
    { label: 'Daily at 11 PM', value: '0 23 * * *' },
    { label: 'Weekly on Sunday at Midnight', value: '0 0 * * 0' },
    { label: 'Weekly on Monday at Midnight', value: '0 0 * * 1' },
    { label: 'Weekly on Tuesday at Midnight', value: '0 0 * * 2' },
    { label: 'Weekly on Wednesday at Midnight', value: '0 0 * * 3' },
    { label: 'Weekly on Thursday at Midnight', value: '0 0 * * 4' },
    { label: 'Weekly on Friday at Midnight', value: '0 0 * * 5' },
    { label: 'Weekly on Saturday at Midnight', value: '0 0 * * 6' },
    { label: 'Monthly on 1st at Midnight', value: '0 0 1 * *' },
    { label: 'Monthly on 15th at Midnight', value: '0 0 15 * *' },
    { label: 'Monthly on Last Day at Midnight', value: '0 0 L * *' },
    { label: 'Every Weekday at 8 AM', value: '0 8 * * 1-5' },
    { label: 'Every Weekend at 10 AM', value: '0 10 * * 6,0' },
    { label: 'Every Monday and Friday at 9 AM', value: '0 9 * * 1,5' },
    { label: 'Every Tuesday and Thursday at 4 PM', value: '0 16 * * 2,4' },
    { label: 'Every 5 Minutes Weekdays Only', value: '*/5 * * * 1-5' },
    { label: 'Every Hour on Weekends Only', value: '0 * * * 6,0' },
    { label: 'Quarterly (Jan, Apr, Jul, Oct) on 1st at Midnight', value: '0 0 1 1,4,7,10 *' },
    { label: 'Biannually (Jan, Jul) on 1st at Midnight', value: '0 0 1 1,7 *' },
    { label: 'Annually on Jan 1st at Midnight', value: '0 0 1 1 *' },
    { label: 'Every 15th and Last Day at 11 PM', value: '0 23 15,L * *' },
    { label: 'Every Monday at 6 AM', value: '0 6 * * 1' },
    { label: 'Every Monday at Noon', value: '0 12 * * 1' },
    { label: 'Every Sunday at 5 PM', value: '0 17 * * 0' },
    { label: 'Every Saturday at 10 PM', value: '0 22 * * 6' },
    { label: 'Every Friday at 3 PM', value: '0 15 * * 5' },
    { label: 'Every 1st and 15th of Month at 6 AM', value: '0 6 1,15 * *' },
    { label: 'Twice a Day: 6 AM and 6 PM', value: '0 6,18 * * *' },
    { label: 'Three Times a Day: 6 AM, 2 PM, 10 PM', value: '0 6,14,22 * * *' },
    { label: 'Every 10 Minutes during Business Hours (9–5)', value: '*/10 9-17 * * *' },
    // Edge & custom cases
    { label: 'First Monday of the Month at 8 AM', value: '0 8 1-7 * 1' },
    { label: 'Every 2nd Tuesday at Noon', value: '0 12 8-14 * 2' },
    { label: 'Every Last Friday of the Month at 5 PM', value: '0 17 * * 5#5' }, // not supported by all engines
    { label: 'Weekdays at 9 AM and 5 PM', value: '0 9,17 * * 1-5' },
    // Generic intervals
    { label: 'Every 45 Minutes', value: '*/45 * * * *' },
    { label: 'Every 90 Minutes', value: '0 */1,*/3 * * *' },
    { label: 'Every 2 Days at Midnight', value: '0 0 */2 * *' },
    { label: 'Every 3 Days at 2 PM', value: '0 14 */3 * *' },
    { label: 'Every 4 Days at 8 AM', value: '0 8 */4 * *' },
    { label: 'Every 6 Days at 6 PM', value: '0 18 */6 * *' },
    // Unusual patterns
    { label: 'Every 29th February at Midnight (leap year)', value: '0 0 29 2 *' },
    { label: 'Every Hour on the 1st Monday of the Month', value: '0 * 1-7 * 1' },
    { label: 'First Day of Month at 6:30 AM', value: '30 6 1 * *' },
    { label: 'Midnight on Sundays and Wednesdays', value: '0 0 * * 0,3' },
    { label: 'Every 15 Minutes on Weekends', value: '*/15 * * * 6,0' },
    { label: 'Every Business Day at 9:15 AM', value: '15 9 * * 1-5' },
];
export default function ViewAllJobs() {
    var _a = useState(initialData), data = _a[0], setData = _a[1];
    var navigate = useNavigate();
    var _b = useState(true), sidePanelOpen = _b[0], setSidePanelOpen = _b[1];
    var _c = useState(false), isMobile = _c[0], setIsMobile = _c[1];
    var _d = useState(null), selectedRowIndex = _d[0], setSelectedRowIndex = _d[1];
    var _e = useState(false), showModal = _e[0], setShowModal = _e[1];
    var _f = useState(null), deleteId = _f[0], setDeleteId = _f[1];
    var _g = useState(false), showUpdateModal = _g[0], setShowUpdateModal = _g[1];
    var _h = useState(null), editRow = _h[0], setEditRow = _h[1];
    var apiResponse = useQuery('/cron').data;
    var _j = useMutation(), deleteTrigger = _j.trigger, deleteData = _j.data, deleteLoading = _j.loading, deleteError = _j.error;
    var _k = useMutation(), updateTrigger = _k.trigger, updateData = _k.data, updateLoading = _k.loading, updateError = _k.error;
    useEffect(function () {
        var checkIfMobile = function () {
            var mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            if (mobile) {
                setSidePanelOpen(false);
            }
        };
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return function () { return window.removeEventListener('resize', checkIfMobile); };
    }, []);
    var sortData = function (key, direction) {
        var sorted = __spreadArray([], data, true).sort(function (a, b) {
            var _a, _b, _c, _d;
            if (((_a = a[key]) !== null && _a !== void 0 ? _a : '') < ((_b = b[key]) !== null && _b !== void 0 ? _b : ''))
                return direction === 'asc' ? -1 : 1;
            if (((_c = a[key]) !== null && _c !== void 0 ? _c : '') > ((_d = b[key]) !== null && _d !== void 0 ? _d : ''))
                return direction === 'asc' ? 1 : -1;
            return 0;
        });
        setData(sorted);
    };
    var handleDelete = function () {
        if (selectedRowIndex !== null) {
            deleteTrigger("/cron?cronJobId=".concat(deleteId), 'DELETE', '')
                .then(function (res) {
                console.log('Response:', res);
                setData(function (prev) {
                    return prev.map(function (item, idx) { return (idx === selectedRowIndex ? __assign(__assign({}, item), { deleted: true }) : item); });
                });
                setShowModal(false);
                setSelectedRowIndex(null);
                toast.success('Row deleted successfully!');
            })
                .catch(function (err) {
                console.error('Error:', err);
                toast.error(err.message || 'Something went wrong');
                // Handle error response
            });
        }
    };
    // Filter out deleted items before rendering
    var visibleData = data.filter(function (item) { return !item.deleted; });
    var getLabelFromCron = function (value) { var _a; return ((_a = frequencies.find(function (f) { return f.value === value; })) === null || _a === void 0 ? void 0 : _a.label) || 'Unknown'; };
    function updatedFunc(updatedData) {
        deleteTrigger("/cron", 'PUT', {
            jobName: updatedData.jobname,
            jobEncType: 'aes-256-cbc',
            scheduleType: 'cron',
            dateTime: editRow === null || editRow === void 0 ? void 0 : editRow.dateTime,
            notificationEmail: updatedData.notificationEmail,
            frequency: updatedData.frequency,
            configId: editRow === null || editRow === void 0 ? void 0 : editRow.configId,
            cronJobId: editRow === null || editRow === void 0 ? void 0 : editRow.id,
        })
            .then(function (res) {
            console.log('Response:', res);
            setData(function (prev) {
                return prev.map(function (item) {
                    return item.id === (updatedData === null || updatedData === void 0 ? void 0 : updatedData.id)
                        ? __assign(__assign(__assign({}, item), updatedData), { config: updatedData.jobname, frequeny: getLabelFromCron(updatedData.frequency) }) : item;
                });
            });
            setShowUpdateModal(false);
            setEditRow(null);
            toast.success('Row updated successfully!');
        })
            .catch(function (err) {
            console.error('Error:', err);
            toast.error('Failed to update the row. Please try again.');
            // Handle error response
        });
    }
    function formatDuration(durationStr) {
        var duration = moment.duration(durationStr);
        var totalSeconds = duration.asSeconds();
        if (totalSeconds < 60) {
            return "".concat(Math.floor(totalSeconds), "s");
        }
        else {
            var minutes = Math.floor(duration.asMinutes());
            var seconds = Math.floor(duration.seconds()); // remainder seconds
            return "".concat(minutes, "m ").concat(seconds, "s");
        }
    }
    useEffect(function () {
        if (apiResponse && apiResponse.length > 0) {
            var transformedData = apiResponse.map(function (item) { return ({
                config: item.jobName,
                encryptionType: item.jobEncType,
                scheduleType: item.scheduleType,
                notificationEmail: item.notificationEmail,
                frequeny: getLabelFromCron(item.frequency),
                dateTime: item.dateTime,
                id: item._id,
                configId: item.configId,
                lastJobDuration: item.lastExecutionDuration
                    ? formatDuration(item.lastExecutionDuration)
                    : '',
            }); });
            console.log('transformedData: ', transformedData);
            setData(transformedData);
        }
    }, [apiResponse]);
    return (_jsxs("div", { className: 'flex min-h-screen bg-gray-50', children: [_jsx(SidePanel, { open: !isMobile && sidePanelOpen, onMenuClick: isMobile ? undefined : function () { return setSidePanelOpen(function (prev) { return !prev; }); }, isMobile: isMobile }), _jsx("div", { className: "flex-1 transition-all duration-300 ".concat(isMobile ? 'ml-0' : sidePanelOpen ? 'ml-0' : 'ml-0'), children: _jsxs("div", { className: 'p-2 md:p-2', children: [_jsx(Header, {}), _jsxs("div", { className: 'flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4', children: [_jsx("h1", { className: 'text-xl md:text-2xl font-semibold text-gray-800', children: "Scheduled Jobs" }), _jsxs("div", { className: 'flex flex-col sm:flex-row gap-3 w-full md:w-auto', children: [_jsx(Button, { label: 'View Logs', className: 'px-4 py-2 rounded-lg border border-[#6C63FF] text-blue-800 bg-violet-100 hover:bg-[#e6e1ff] transition font-medium text-md h-12 w-full md:w-auto cursor-pointer', onClick: function () { return navigate('/view-logs'); } }), _jsx(Button, { label: 'Schedule Jobs', icon: _jsx(PlusIcon, {}), className: 'flex items-center bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-800 text-sm font-medium w-full md:w-auto justify-center cursor-pointer', onClick: function () { return navigate('/job-scheduling'); } })] })] }), _jsxs("div", { className: 'bg-white p-4 md:p-6 rounded-xl shadow min-h-screen overflow-x-auto', children: [_jsx("h2", { className: 'text-lg md:text-xl font-semibold text-gray-800 mb-4', children: "All Jobs" }), _jsx("div", { className: 'hidden md:block', children: _jsxs("table", { className: 'w-full table-auto text-sm border-collapse', children: [_jsx("thead", { children: _jsx("tr", { className: 'border-b border-gray-300', children: columns.map(function (col, idx) { return (_jsx("th", { className: 'px-2 py-1 font-semibold text-left', children: _jsxs("div", { className: 'flex items-center justify-between', children: [_jsx("span", { children: col.label }), col.key !== 'edit' && col.key !== 'delete' && col.key !== 'view-log' && (_jsxs("div", { className: 'flex flex-col ml-1 text-gray-500 leading-none', children: [_jsx("button", { onClick: function () { return sortData(col.key, 'asc'); }, className: 'p-0 h-3 hover:text-gray-700', children: _jsx(UpArrow, { className: 'w-2 h-2' }) }), _jsx("button", { onClick: function () { return sortData(col.key, 'desc'); }, className: 'p-0 h-3 hover:text-gray-700', children: _jsx(DownArrow, { className: 'w-2 h-2' }) })] }))] }) }, idx)); }) }) }), _jsx("tbody", { children: visibleData.map(function (row, idx) { return (_jsxs("tr", { className: 'border-gray-300 hover:bg-gray-50', children: [_jsx("td", { className: 'px-2 py-1', children: row.config }), _jsx("td", { className: 'px-2 py-1', children: row.encryptionType }), _jsx("td", { className: 'px-2 py-1', children: row.scheduleType }), _jsx("td", { className: 'px-2 py-1', children: row.notificationEmail }), _jsx("td", { className: 'px-2 py-1', children: row.frequeny }), _jsx("td", { className: 'px-2 py-1', children: row.dateTime }), _jsx("td", { className: 'px-2 py-1 cursor-pointer', onClick: function () {
                                                                setEditRow(row);
                                                                setShowUpdateModal(true);
                                                            }, children: _jsx(EditIcon, { className: 'w-4 h-4' }) }), _jsx("td", { className: 'px-2 py-1 ', children: _jsx("button", { className: 'text-red-600 hover:text-red-800 cursor-pointer', onClick: function () {
                                                                    setSelectedRowIndex(data.indexOf(row));
                                                                    setShowModal(true);
                                                                    setDeleteId(row.id);
                                                                    console.log('Delete ID:', row.id);
                                                                }, children: _jsx(TrashIcon, { className: 'w-4 h-4' }) }) }), _jsx("td", { className: 'cursor-pointer px-2 py-1 text-red-500', onClick: function () { return navigate("/specific-job-logs?jobId=".concat(row.id)); }, children: "All Logs" }), _jsx("td", { className: 'px-2 py-1 text-green-500', children: row.lastJobDuration })] }, idx)); }) })] }) }), _jsx("div", { className: 'md:hidden space-y-4', children: visibleData.map(function (row, idx) { return (_jsxs("div", { className: 'border border-gray-200 rounded-lg p-4 hover:bg-gray-50', children: [_jsxs("div", { className: 'grid grid-cols-2 gap-4 mb-3', children: [_jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Config" }), _jsx("p", { className: 'font-medium', children: row.config })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Encryption Type" }), _jsx("p", { className: 'font-medium', children: row.encryptionType })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Schedule Type" }), _jsx("p", { className: 'font-medium', children: row.scheduleType })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Notification Email" }), _jsx("p", { className: 'font-medium', children: row.notificationEmail })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Frequency" }), _jsx("p", { className: 'font-medium', children: row.frequeny })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Date & Time" }), _jsx("p", { className: 'font-medium', children: row.dateTime })] }), _jsxs("div", { className: 'cursor-pointer', onClick: function () { return navigate("/specific-job-logs?jobId=".concat(row.id)); }, children: [_jsx("p", { className: 'text-xs text-red-500', children: "All Logs" }), _jsx("p", { className: 'font-medium', children: row.viewLog })] }), _jsxs("div", { children: [_jsx("p", { className: 'text-xs text-gray-500', children: "Last Job Duration" }), _jsx("p", { className: 'font-medium', children: row.lastJobDuration })] })] }), _jsx("div", { className: 'flex justify-between items-center border-t border-gray-100 pt-3', children: _jsxs("div", { className: 'flex gap-3', children: [_jsx("button", { className: 'text-blue-600 hover:underline cursor-pointer', onClick: function () {
                                                                setEditRow(row);
                                                                setShowUpdateModal(true);
                                                            }, children: _jsx(EditIcon, { className: 'w-4 h-4' }) }), _jsx("button", { className: 'text-red-600 hover:text-red-800 cursor-pointer', onClick: function () {
                                                                setSelectedRowIndex(data.indexOf(row)); // Use original index
                                                                setShowModal(true);
                                                                setDeleteId(row.id);
                                                            }, children: _jsx(TrashIcon, { className: 'w-5 h-5' }) })] }) })] }, idx)); }) })] })] }) }), showUpdateModal && editRow && (_jsx(UpdateCronModal, { isOpen: showUpdateModal, onClose: function () {
                    setShowUpdateModal(false);
                    setEditRow(null);
                }, rowData: editRow, onUpdate: function (updatedData) {
                    console.log('Updated Data:', updatedData);
                    updatedFunc(updatedData);
                } })), _jsx(DeleteModal, { isOpen: showModal, onClose: function () {
                    setShowModal(false);
                    setSelectedRowIndex(null);
                }, onConfirm: handleDelete })] }));
}
